import { makeAutoObservable } from 'mobx'
import { nanoid } from 'nanoid'
import { showToast } from 'shared/ui'
import { logger } from 'shared/lib'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { ReviewsApi } from 'entities/Review'

export class ReviewActionsStore {
  constructor() {
    makeAutoObservable(this)
  }

  onDelete = (id: number, onSuccess?: () => void) => {
    const idModal = nanoid()

    modalStore.addModal({
      id: idModal,
      title: 'Delete review page?',
      desc: 'This action cannot be undone',
      type: ModalTypeList.ALERT,
      showCloseButton: false,
      primaryAction: {
        text: 'Delete',
        onAction: async () => {
          try {
            await ReviewsApi.deleteReview(id)
            showToast({ type: 'success', title: 'Review page deleted' })
            onSuccess?.()
            modalStore.closeModal(idModal)
          } catch (e) {
            logger.error(e)
            showToast({ type: 'error', title: 'Something went wrong. Please try again' })
          }
        },
      },
      secondaryAction: {
        text: 'Cancel',
        onAction: () => modalStore.closeModal(idModal),
      },
    })
  }
}
